<template>
  <b-navbar
    toggleable="md"
    variant="light"
    type="light"
    fixed
    :class="$style.mobileNav"
  >
    <!-- Shoping bag icon -->
    <b-navbar-brand
      :class="$style.navLogoWrapper"
      :to="{ name: 'PublicSiteHome', props: { site: slug } }"
    >
      <img
        ref="glyph"
        src="@assets/images/soc-logo-02.png"
        alt="logo"
        :class="$style.glyph"
      />
      <!-- <img
                      ref="glyph"
                      src="@assets/images/shop-with-us-02.png"
                      alt="logo"
                      :class="$style.glyph"
                    /> -->
    </b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse
      id="nav-collapse"
      is-nav
    >
      <b-navbar-nav>
        <b-nav-item
          active
          :to="{
            name: 'PublicSiteHome',
            params: { site: slug },
          }"
        >Home</b-nav-item>
        <b-nav-item-dropdown
          text="Store"
          class="d-none d-md-block d-xl-none"
        >
          <!-- <b-dropdown-item href="#" :to="{ name: 'how-it-works' }"
            >How it Works</b-dropdown-item
          > -->
          <b-dropdown-item :to="{ name: 'locations' }">Locations</b-dropdown-item>
          <b-dropdown-item :to="{ name: 'categories' }">Browse Categories</b-dropdown-item>
        </b-nav-item-dropdown>
        <!-- <b-nav-item
          class="d-block d-md-none"
          :to="{ name: 'how-it-works' }"
        >How it Works</b-nav-item> -->
        <b-nav-item
          class="d-block d-md-none"
          :to="{ name: 'locations' }"
        >Locations</b-nav-item>
        <b-nav-item
          class="d-block d-md-none"
          :to="{ name: 'categories' }"
        >Browse Categories</b-nav-item>
        <!-- For md and large screens -->
        <b-nav-item-dropdown
          text="Account"
          class="d-none d-md-block d-xl-none"
        >
          <!-- Logged in routes -->
          <b-dropdown-item
            v-if="loggedIn"
            :to="{ name: 'profile' }"
          >{{ currentUser.firstName }}'{{
              currentUser.firstName.slice(-1) === 's' ? '' : 's'
            }}
            account</b-dropdown-item>
          <b-dropdown-item
            v-if="loggedIn"
            @click="logout"
          >Log Out
            <font-awesome-icon :icon="['fal', 'ban']" />
          </b-dropdown-item>
          <!-- Logged out routes -->
          <b-dropdown-item
            v-if="!loggedIn"
            :to="{ name: 'signup', props: { site: slug } }"
          >Sign Up <b-icon icon="person"></b-icon>
          </b-dropdown-item>
          <b-dropdown-item
            v-if="!loggedIn"
            :to="{ name: 'login' }"
          >Login</b-dropdown-item>
        </b-nav-item-dropdown>
        <!-- Logged in routes -->
        <b-nav-item
          v-if="loggedIn"
          class="d-block d-md-none"
          :to="{ name: 'profile' }"
        >{{ currentUser.firstName }}'{{
            currentUser.firstName.slice(-1) === 's' ? '' : 's'
          }}
          account</b-nav-item>
        <b-nav-item
          v-if="loggedIn"
          class="d-block d-md-none"
          @click="logout"
        >Log Out
          <font-awesome-icon :icon="['fal', 'ban']" />
        </b-nav-item>
        <!-- Logged out routes -->
        <b-nav-item
          v-if="!loggedIn"
          class="d-block d-md-none"
          :to="{ name: 'signup', props: { site: slug } }"
        >Sign Up <b-icon icon="person"></b-icon>
        </b-nav-item>
        <b-nav-item
          v-if="!loggedIn"
          class="d-block d-md-none"
          :to="{ name: 'login' }"
        >Login</b-nav-item>
        <b-nav-item :to="{ name: 'cart', props: { site: slug } }">
          <div
            class="text-left"
            :class="$style.cartIconWrapper"
          >
            <span>
              Cart
            </span>
            <BaseIcon
              name="shopping-cart"
              library="fal"
            />
            <span :class="$style.cartBadge">
              {{ cartSize }}
            </span>
          </div>
        </b-nav-item>
      </b-navbar-nav>
      <b-nav-form
        ref="searchBar"
        :class="$style.searchBoxWrapper"
        @submit="triggerSearch"
      >
        <b-form-input
          v-model="searchValue"
          :class="$style.searchBox"
          size="sm"
          class="mr-sm-2"
          placeholder="Search"
        ></b-form-input>
        <b-button
          squared
          size="sm"
          :class="$style.searchButton"
          type="submit"
        >Go</b-button>
      </b-nav-form>
    </b-collapse>
  </b-navbar>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { authComputed } from '@state/helpers'

export default {
  data() {
    return {
      searchValue: '',
    }
  },

  computed: {
    ...authComputed,
    ...mapGetters({
      slug: 'sites/getSiteSlug',
      cartSize: 'shoppingCart/getCartLength',
      loggedIn: 'auth/loggedIn',
      currentUser: 'auth/getUser',
    }),
  },

  methods: {
    ...mapActions({
      triggerLogout: 'auth/logOut',
    }),
    logout: function () {
      if (this.accountPage) {
        this.$router.push({
          name: 'PublicSiteHome',
          params: { site: this.slug },
        })
      }
      this.triggerLogout()
    },

    triggerSearch(evt) {
      evt.preventDefault()
      this.$router.push({
        name: 'category-page',
        params: { site: this.slug },
        query: { q: this.searchValue, 'page[number]': 1 },
      })
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';

.mobileNav {
  margin-top: -6px;
  margin-right: -15px;
  margin-left: -15px;
}

.glyph {
  position: relative;
  z-index: 500;
  width: 40px;
}

.searchBoxWrapper {
  margin-left: auto;
}

.searchLink {
  opacity: 0;
}

.searchBox {
  width: 280px !important;
  height: 3rem;
  padding: 12px 10px !important;
  color: #444;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 0;
  &:focus {
    border: 1px solid rgba(0, 0, 0, 0.1) !important;
  }
}

.searchButton {
  position: relative;
  top: -1px;
  padding: 12px;
  color: var(--brandColor);
  background-color: #fff;
  border: 1px solid var(--brandColor);
}
</style>
